import acl from "@/plugins/acl";

export default function (to, from, next) {
  if (to.meta.slug && acl.can(to.meta.slug)) {
    next();
    return;
  }
  next({ name: from.name ? from.name : "feed" });
}
